import * as React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../components";
import { AbstractSummary, AdminAbstractAndTypeLoader } from "../../../containers/abstracts/components";
import * as M from "../../../models";

interface OwnProps {
    onClose: () => void;
}

interface OwnState {
    abstract?: M.Abstract.Abstract;
    guid?: string;
    loading: boolean;
    show: boolean;
    type?: M.Abstract.AbstractType;
}

export class AbstractDetailsModal extends Comp.Base.BaseComponent<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            show: false,
        };
    }

    public async close() {
        await this.setStateAsync({
            ...this.state,
            abstract: undefined,
            guid: undefined,
            show: false,
        });

        this.props.onClose();
    }

    public open(guid: string) {
        this.setStateAsync({
            ...this.state,
            guid,
            show: true,
        });
    }

    public render() {
        const a = this.state.abstract;
        const type = this.state.type;

        const modalProps: BS.ModalProps = {
            backdrop: "static",
            bsSize: "lg",
            keyboard: true,
            onEscapeKeyDown: () => this.close(),
            onHide: () => {},
            show: this.state.show,
        } as any; // needed "as any" here because "onEscapeKeyDown" does not exist in the latest typed definitions of react-bootstrap

        return <BS.Modal { ...modalProps }>
                <BS.Modal.Header bsClass="modal-header alert-info" closeButton onHide={() => this.close()}>
                    <BS.Modal.Title dangerouslySetInnerHTML={{ __html: a ? `Abstract #${a.id} - ${a.title}` : "" }} />
                </BS.Modal.Header>

                <BS.Modal.Body>
                    {this.state.guid
                        ? <AdminAbstractAndTypeLoader
                            guid={this.state.guid}
                            onDataUpdated={async (dataLoading, updatedAbstract, updatedType) => await this.setStateAsync({
                                ...this.state,
                                abstract: updatedAbstract,
                                type: updatedType,
                                loading: dataLoading,
                            })}
                            onErrors={(errors) => this.setErrors(errors)}
                            // onLoadingUpdated={async (updatedLoading) => await this.setStateAsync({ ...this.state, loading: updatedLoading })}
                        />
                        : null}

                    {this.getErrorAlert()}

                    {
                        a && type
                            ? <AbstractSummary
                                abstract={a}
                                isAdmin={true}
                                type={type}
                            />
                            : <div style={{ position: "relative", height: "200px" }}>
                                <Comp.Generic.LoadingSpinner show={true} />
                            </div>
                    }
                </BS.Modal.Body>

                <BS.Modal.Footer>
                    <BS.Button bsStyle="link" onClick={() => this.close()}>Close</BS.Button>
                </BS.Modal.Footer>
            </BS.Modal>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/components/AbstractDetailsModal.tsx